import { render, staticRenderFns } from "./PublicationSuccess.vue?vue&type=template&id=d3910a6a&scoped=true&"
import script from "./PublicationSuccess.vue?vue&type=script&lang=js&"
export * from "./PublicationSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3910a6a",
  null
  
)

export default component.exports